module.exports = __webpack_public_path__ + "static/img/photo-icon.23a5396.png";